import {Inject, Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import {HttpClient} from '@angular/common/http';


@Injectable()
export class InternalService {
  public key: any;
  public isParent: any;
  public androidLink: any ='https://www.alobodo.com/Alobodo.apk';

  constructor(public translate: TranslateService, public apiService: ApiService,
    private dbService: NgxIndexedDBService,) {
  }

  async getMd5(image) {
    
    if (image.includes("https://")) {
      return image
    } else {
      const result = await this.dbService.getByIndex('Images', 'MD5', image).toPromise();
      // debugger
      if (result === undefined || result.icon == "data:image/png;base64,undefined") {
// ----------------------------------------check number of rows in a store-------------------------
        this.dbService.count('Images').subscribe((count) => {
          // console.log('count', count);
          if (count > 100) {
            this.dbService.clear('Images').subscribe((successDeleted) => {
              // console.log('success? ', successDeleted);
            });
          }
        });
// ------------------------------------------------insert store-------------------------------------
        const response = await this.apiService.getImage(image).toPromise();
        // debugger
        this.dbService
          .add('Images', {
            MD5: image,
            // icon: response['res']['imageFormat'] + response['res']['imageString'],
            icon: `data:image/png;base64,`+ response['res']['imageString'],
          });
        return `data:image/png;base64,`+ response['res']['imageString'];
      } else {
        return result.icon;
      }
    }
  }

  async getSkillMd5(image) {
    
    if (image.includes("https://")) {
      return image
    } else {
      const result = await this.dbService.getByIndex('Images', 'MD5', image).toPromise();
      
      if (result === undefined || result.icon == "data:image/png;base64,undefined") {
// ----------------------------------------check number of rows in a store-------------------------
        this.dbService.count('Images').subscribe((count) => {
          // console.log('count', count);
          if (count > 100) {
            this.dbService.clear('Images').subscribe((successDeleted) => {
              // console.log('success? ', successDeleted);
            });
          }
        });
// ------------------------------------------------insert store-------------------------------------
        const response = await this.apiService.getSkillImage(image).toPromise();
        
        this.dbService
          .add('Images', {
            MD5: image,
            // icon: response['res']['imageFormat'] + response['res']['imageString'],
            icon: `data:image/png;base64,`+ response['res']['imageString'],
          });
        return `data:image/png;base64,`+ response['res']['imageString'];
      } else {
        return result.icon;
      }
    }
  }


  changeLang(language: string, id) {
    if (language === 'fa-ir') {
      localStorage.setItem('lang', '1');
      document.title = 'الوبدو'
    } else {
      localStorage.setItem('lang', '2');
      document.title = 'Alobodo'
    }
    // the methode for change lang and direction of whole website
    this.translate.use(language);
    this.translate.get('dir', language).subscribe(
      (res) => {

        this.apiService.currentDirection = res;

        const dom: any = document.querySelector('body');

        if (res === 'rtl' && !dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 1);
          dom.classList.toggle('rtl');

          if (id !== 0) {
            window.location.reload();
          }
        }
        if (res === 'ltr' && dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 2);
          dom.classList.toggle('rtl');
          if (id !== 0) {
            window.location.reload();
          }
        }
      }
    );
  }
  setIsLeaf() {
    // localStorage.setItem('isLeaf', 'false');
  }
  setIsLeafTrue() {
    // localStorage.setItem('isLeaf', 'true');
  }
  getRideOfSpace(text){
    return text.replace(/\s/g, '-')
  }

}
